import React from 'react';
import * as S from './styles';

function LeftContent() {
  return (
    <S.Wrapper>
      <S.Title>Dois fins de semana podem realmente mudar tudo!</S.Title>
      <S.Description>O ACE é um intensivo de <strong>inteligência emocional</strong>, que já transformou a vida de mais de 450 pessoas.</S.Description>
      <S.Description>Aproveite essa oportunidade e garanta sua vaga para a próxima turma.</S.Description>
    </S.Wrapper>
  );
}

export default LeftContent;
